<template>
  <v-dialog
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
  >
    <v-card flat>
      <v-card-text class="align-center">
        <v-icon class="success--text" size="50">thumb_up</v-icon>
        <v-layout
          column
          align-center
          class="subheading pa-2 success--text font-weight-bold"
        >
          Well Done!
        </v-layout>
        <v-divider class="my-3" />

        <v-layout column align-center class="text-xs-left">
          You've successfully completed all payments.
        </v-layout>

        <v-divider class="my-3" />

        <v-layout align-center>
          <v-btn
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="goToDashboard"
          >
            Go to Dashboard
          </v-btn>
          <v-btn
            v-if="k1DistributionApplicable"
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="goToK1Distribution"
          >
            Distribute K-1 Packages
          </v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';

export default {
  mixins: [FirmPreferenceMixins],

  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    taxReturn: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),

    k1DistributionApplicable() {
      return (
        this.isEmbeddedInNext &&
        this.taxReturnK1DistributionEnabled &&
        this.taxReturn.k1_distribution_status !== 'not_applicable' &&
        this.taxReturn.k1_packages.length > 0
      );
    },
  },

  methods: {
    goToK1Distribution() {
      window.location.href = '/?k1-distribution-id=' + this.taxReturn.id;
    },

    goToDashboard() {
      if (this.isEmbeddedInNext) {
        window.location.href = '/';
      } else if (this.$route.params.hash) {
        this.$router.push(`/${this.$route.params.hash}`);
      } else {
        this.$router.push(`/?companyId=${this.taxReturn.company_id}`);
      }
    },
  },
};
</script>
